const goog: any = {};

export default goog;
